import { Box, Chip, Typography } from "@mui/material";
import { _date, formatMoney } from "../../../utils/helpers";

function getColorByDirection(direction) {
    return direction === "expense" ? "error" : "success";
}

function getChipColor(value) {
    const normalized = String(value || "").toLowerCase();
    if (["processed", "income", "purchase", "purchase_income"].includes(normalized)) return "success";
    if (["pending", "manual", "manual_income", "manual_expense"].includes(normalized)) return "warning";
    if (["failed", "canceled", "cancelled", "expense", "salary", "teacher_salary"].includes(normalized)) return "error";
    return "default";
}

export const IncomeExpenseColumns = () => [
    {
        id: "effective_date",
        label: "Date",
        render: (value, row) => (
            <Typography variant="body2" sx={{ textAlign: "center" }}>
                {_date(row.effective_date, { relative: false, long: false })}
            </Typography>
        ),
    },
    {
        id: "direction",
        label: "Direction",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip
                    size="small"
                    color={getColorByDirection(row.direction)}
                    label={row.direction === "expense" ? "Expense" : "Income"}
                />
            </Box>
        ),
    },
    {
        id: "source",
        label: "Source",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip
                    size="small"
                    variant="outlined"
                    color={getChipColor(row.source)}
                    label={row.source || "—"}
                />
            </Box>
        ),
    },
    {
        id: "type",
        label: "Type",
        render: (value, row) => {
            const label = row.expense_type?.name || row.type || "—";
            return (
                <Box sx={{ textAlign: "center" }}>
                    <Chip
                        size="small"
                        variant="outlined"
                        color={row.expense_type?.name ? "primary" : getChipColor(row.type)}
                        label={label}
                    />
                </Box>
            );
        },
    },
    {
        id: "status",
        label: "Status",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip
                    size="small"
                    color={getChipColor(row.status)}
                    label={row.status || "—"}
                />
            </Box>
        ),
    },
    {
        id: "amount",
        label: "Amount",
        render: (value, row) => (
            <Box sx={{ textAlign: "center" }}>
                <Chip
                    size="small"
                    variant="outlined"
                    color={getColorByDirection(row.direction)}
                    label={formatMoney(Number(row.amount || 0))}
                />
            </Box>
        ),
    },
    {
        id: "description",
        label: "Description",
        render: (value, row) => (
            <Typography variant="body2" sx={{ textAlign: "center", maxWidth: 360, mx: "auto" }}>
                {row.related_student_name
                    ? `Student: ${row.related_student_name}${row.description ? ` • ${row.description}` : ""}`
                    : (row.description || "—")}
            </Typography>
        ),
    },
];

